import { listSupervisedBanks, listSupervisorGroups } from '../api/supervisor';
import { labelWithSeq } from '../components/ScopeField';
import { normalizeBankSeq } from '../api/banks';

// Pas de cache module-level ici (contrairement a utils/lotteryLookup.js, qui
// sert un catalogue GLOBAL identique pour tous) : la liste banks/groups est
// PROPRE a chaque superviseur connecte — un cache partage risquerait de
// resoudre les mauvaises donnees d'une session a l'autre. Les listes sont de
// toute facon petites (quelques banks/groups par superviseur), pas besoin
// d'optimiser un appel declenche seulement au blur d'un champ.

/**
 * Resout le NUMERO tape par le superviseur (Bank.seq — propre a la company,
 * pas l'id Django interne, cf. banks/models.py) -> { id, name } ou null si
 * introuvable/hors perimetre du superviseur connecte (listSupervisedBanks()
 * est deja scope cote backend a Supervisor.covered_bank_ids()). `id` retourne
 * reste le vrai PK Django : c'est lui qu'attend la soumission de scope
 * derriere (SupervisorBankBulkStatusView, scope=<id>), seul l'AFFICHAGE/la
 * SAISIE se fait desormais via seq.
 */
export async function resolveSupervisorBankById(seq) {
  // "19-19" / "05" (REF imprime sur la fiche) -> "19" / "5", cf. normalizeBankSeq.
  const s = normalizeBankSeq(seq);
  if (!s) return null;
  const list = await listSupervisedBanks().catch(() => []);
  const found = list.find((b) => String(b.seq) === s);
  return found ? { id: String(found.id), name: labelWithSeq(found.seq, found.name) } : null;
}

/**
 * Meme principe que resolveSupervisorBankById, pour Group.seq
 * (listSupervisorGroups() deja scope a Group.supervisor==self).
 */
export async function resolveSupervisorGroupById(seq) {
  const s = String(seq ?? '').trim();
  if (s === '') return null;
  const list = await listSupervisorGroups().catch(() => []);
  const found = list.find((g) => String(g.seq) === s);
  // Groupe : display_name contient deja le N° ("group1-1").
  return found ? { id: String(found.id), name: found.display_name || found.name } : null;
}
